module.exports = __webpack_public_path__ + "static/media/IMEX-Logo.7e1417b3.svg";